import { render, staticRenderFns } from "./postnl-verhuisservice.vue?vue&type=template&id=26f767a9"
import script from "./postnl-verhuisservice.vue?vue&type=script&lang=js"
export * from "./postnl-verhuisservice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports